import { useQuery } from "@tanstack/vue-query";
import { useGeoMasterDataApi } from "@/features/core-shared/composables/useGeoMasterDataApi";

export function useCurrenciesMasterdataQuery() {
  const geoMasterDataApi = useGeoMasterDataApi();
  return useQuery({
    queryKey: ["currencies-masterdata"],
    queryFn: () => geoMasterDataApi.getCurrencies(),
    select: ({ data }) => data,
  });
}
